<template>
  <page>
    <module enable-flex ref="view">
      <m-search ref="search" @search="searchHandle">
        <c-form>
            <c-form-item type="input" label="代理信息" name="user_info" placeholder="模糊匹配昵称、手机号"></c-form-item>
            <c-form-item type="input" label="商品信息" name="product_info" placeholder="模糊匹配货号、名称"></c-form-item>
            <c-form-item type="input" label="商品规格" name="product_sku_spec"
                         placeholder="模糊匹配商品规格"></c-form-item>
            <c-form-item type="input" label="SKU编码" name="product_sku_code" placeholder="精确匹配"></c-form-item>
            <c-form-item type="checkbox" label="变更业务" name="stock_type" :options="stockType"></c-form-item>
            <c-form-item type="checkbox" label="库存增减" name="income_expenses"
                         :options="incomeExpensesType"></c-form-item>
            <c-form-item type="input" label="关联订单" name="order_number"></c-form-item>
            <c-form-item type="datetime" label="发生时间" start-name="start_date" end-name="end_date"></c-form-item>
        </c-form>
      </m-search>
      <m-operate>
        <c-button color="m" hollow @click="syncExport()">导出台账数据</c-button>

        <template #right>
          <c-button v-if="userInfo.id == 1" color="red" @click="$refs.view.editExportColumn(workType)">编辑导出列</c-button>
        </template>
      </m-operate>
      <c-table ref="table">
        <c-table-column type="selector"></c-table-column>

        <c-table-column label="代理头像/昵称" name="nick_name" width="200">
          <template v-slot="{data}">
            <div class="flex-center-cross">
              <c-image :src="data.head_photo" preview size="30" style="margin-right: 10px;">
              </c-image>
              <span>{{ data.nick_name || '--' }}</span>
            </div>
          </template>
        </c-table-column>

        <c-table-column label="代理手机号" name="user_manage_mobilephone" width="120">
          <template v-slot="{data}">
            <span>{{ data.user_manage_mobilephone }}</span>
          </template>
        </c-table-column>

        <c-table-column
            label="商品信息"
            name="product_name"
            width="250"
        >
          <template v-slot="{data}">
            <product-info v-if="data.product_itemnumber" :image="data.product_img_url"
                          :name="data.product_itemnumber + ' - '+data.product_name"></product-info>
            <product-info v-else :image="data.product_img_url" :name="data.product_name"></product-info>
          </template>
        </c-table-column>

        <c-table-column
            label="规格名称"
            name="product_sku_spec"
            width="90"
        ></c-table-column>

        <c-table-column
            label="SKU编码"
            name="product_sku_code"
            width="150"
        ></c-table-column>

        <c-table-column
            label="变更业务"
            name="stock_type"
            width="80"
        >
          <template v-slot="{data}">
            <span>{{stockTypeName[data.stock_type] }}</span>
          </template>
        </c-table-column>

        <c-table-column
            label="库存增减"
            name="income_expenses"
            width="80"
        >
          <template v-slot="{data}">
            <span v-if="data.income_expenses == 2" style="color: red">减少</span>
            <span v-if="data.income_expenses == 1" style="color: green">增加</span>
          </template>
        </c-table-column>

        <c-table-column
            label="变更数量"
            name="product_count"
            width="80"
        >
          <template v-slot="{data}">
            <span v-if="data.income_expenses == 2" style="color: red">{{ data.product_count }}</span>
            <span v-if="data.income_expenses == 1" style="color: green">{{ data.product_count }}</span>
          </template>
        </c-table-column>

        <c-table-column
            label="变更后库存"
            name="remain_product_count"
            width="100"
        >
        </c-table-column>

        <c-table-column
            label="关联订单"
            name="order_number"
            width="150"
        >
          <template v-slot="{data}">
            <span v-if="data.order_number">{{ data.order_number }}</span>
            <span v-else>--</span>
          </template>
        </c-table-column>

        <c-table-column
            label="备注"
            name="remark"
            width="250"
        >
          <template v-slot="{data}">
            <span v-if="data.remark">{{ data.remark }}</span>
            <span v-else-if="data.stock_type == 2">总后台会员【{{ data.stock_user_name }}】直接调整云仓库存</span>
            <span v-else>--</span>
          </template>
        </c-table-column>

        <c-table-column
            label="发生时间"
            name="create_date"
            width="150"
        >
        </c-table-column>
      </c-table>
    </module>
  </page>
</template>
<script>
import productInfo from '@/components/public/product_info.vue'
import {mapState} from "vuex";

export default {
  name: 'm_cloud_stock_log',

  components: {
    productInfo
  },

  data() {
    return {
      workType: 30,    //云仓台账业务代码
      stockType: [
        {name: '云仓囤货', value: 1},
        {name: '后台调整', value: 2},
        {name: '云仓发货', value: 3},
        {name: '云仓提货', value: 4},
        {name: '未发退款', value: -1},
        {name: '退货退款', value: -3},
        {name: '订单关闭', value: -2}
      ],
      stockTypeName: {
        '1': '云仓囤货',
        '2': '后台调整',
        '3': '云仓发货',
        '4': '云仓提货',
        '-1': '未发退款',
        '-3': '退货退款',
        '-2': '订单关闭',
      },
      incomeExpensesType: [
        {name: '库存增加', value: 1},
        {name: '库存减少', value: 2}
      ]
    }
  },

  computed: {
    ...mapState(['systemConfig', 'userInfo'])
  },

  watch: {},

  mounted() {
    this.$refs.search.search();
  },

  methods: {
    searchHandle(data = {}) {
      this.$refs.table.load({
        url: '/cloud/stock/log/list',
        data
      });
    },
    /**同步导出数据*/
    syncExport() {
      var selectDatas = this.$refs.table.getRow('selected');
      var ids = [];
      if (selectDatas.length && selectDatas.length > 0) {
          ids = Array.from(selectDatas, item => item.data.id);
      }
      this.export(this.workType, this.searchParams, ids);
    }
  }
}
</script>

<style lang="stylus" scoped>
.tag {
  border-radius: 2px;
  padding: 0 5px;
  margin-left: 6px;
  line-height: 18px;
  color: #fff;
}
</style>